import { GridRowApi } from "@mui/x-data-grid-pro";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SellersProps } from "components/types";

export interface SellerOnboardingState {
  value: number;
  combinedSelectedSellers: SellersProps[];
}

export const initialState: SellerOnboardingState = {
  value: 1,
  combinedSelectedSellers: [],
};

export const sellerOnboardingSlice = createSlice({
  name: "sellerOnboarding",
  initialState,
  reducers: {
    changeValue: (
      state: SellerOnboardingState,
      action: PayloadAction<number>
    ) => {
      state.value = action.payload;
    },
    addCombinedSelectedSellers: (
      state: SellerOnboardingState,
      action: PayloadAction<SellersProps[]>
    ) => {
      state.combinedSelectedSellers = action.payload;
    },
  },
});

export const { changeValue, addCombinedSelectedSellers } =
  sellerOnboardingSlice.actions;
